import { Injectable } from '@angular/core';
import { McticHttpClient } from '@mctic/ng-core';
import { FaturamentoAntigoVO } from '../shared/model/faturamento-antigo-vo.model';

@Injectable({
  providedIn: 'root'
})
export class FaturamentoAntigoService {

  constructor(private readonly http: McticHttpClient) {
  }

  obterPorFaturamentoProduto(idFaturamentoProduto: number) {
    return this.http.get<FaturamentoAntigoVO>(
      `/sepin-backend/rest/faturamento-antigo-produtos/${idFaturamentoProduto}/faturamentos`
    );
  }

  cadastrar(faturamento: FaturamentoAntigoVO) {
    return this.http.post('/sepin-backend/rest/faturamentos', faturamento);
  }

  atualizar(faturamento: FaturamentoAntigoVO) {
    return this.http.put('/sepin-backend/rest/faturamentos', faturamento);
  }
}
